<app-inbox 
    [table]="tableSubject$ | async" 
    [data]="dataSubject$ | async" 
    (onConsult)="loadMotivos($event)"
>
</app-inbox>